import { ButtonHTMLAttributes } from 'react'
import classNames from 'classnames'

import SVGIcon from '@/components/base/SVGIcon'
import Typography from '@/components/base/Typography'

import { useStore } from '@/contexts/store'

export type LoadMoreProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fetching?: boolean
}

const LoadMore = ({ fetching, ...props }: LoadMoreProps) => {
  const { strings } = useStore()

  return (
    <button
      className="group inline-flex w-full rounded-xxs border border-white/30 bg-transparent px-sm py-[2rem] text-center shadow-3xl"
      {...props}
    >
      <span className="relative mx-auto">
        <span
          data-label={strings?.labels.load_more}
          className={classNames(
            'relative flex overflow-hidden py-[.45rem]',
            'after:absolute after:left-0 after:top-0 after:-my-[.45em] after:w-full after:translate-y-full after:py-[.45rem] after:font-inter after:text-button after:text-white after:transition-transform after:duration-300 after:ease-out-cubic after:content-[attr(data-label)] pointer:group-hover:after:translate-y-0'
          )}
        >
          <Typography
            variant="body"
            className="block text-white transition-transform duration-300 ease-out-cubic pointer:group-hover:-translate-y-full"
          >
            {strings?.labels.load_more}
          </Typography>
        </span>
        <span className="absolute -right-sm top-1/2 h-[2.4rem] w-[2.4rem] -translate-y-1/2 translate-x-full">
          <span
            className={classNames('absolute left-0 top-0 h-full w-full', {
              'animate-rotate': fetching
            })}
          >
            <SVGIcon
              symbol="load-more"
              className="absolute left-1/2 top-1/2 h-[2.5rem] w-[2.4rem] -translate-x-[1.1rem] -translate-y-[1.25rem] fill-white"
            />
          </span>
        </span>
      </span>
    </button>
  )
}

export default LoadMore
